import { NumberAttributeProps } from 'Types/Attribute.types'
import { InputNumber } from 'antd/lib'
import './Number.less'
import React, { useCallback } from 'react'

const NumberAttribute: React.FC<NumberAttributeProps> = props => {
    const handleChange = useCallback(
        (value: number | null) => {
            props.onChange(value ?? undefined)
        },
        [props]
    )

    return (
        <div
            className={`attribute-main ${props.className}`}
            style={{ width: props.width ?? '90%' }}
            data-testid="number-wrapper"
        >
            <span className="attribute-main-title">{props.label}</span>
            <InputNumber
                type={'number'}
                placeholder="Please enter value"
                value={props.value}
                onChange={handleChange}
                disabled={props.readonly}
            />
        </div>
    )
}

export default NumberAttribute
